export const SVSESQUERYDATA = '//svsesapi.haiziwang.com/svses-api/api/queryData.do'//简单自定义搜索接口查询
export const SVSESQUERYALLDATA = '//svsesapi.haiziwang.com/svses-api/api/queryAllData.do'//自定义搜索数据查询